import Vue from 'vue'
import Vuex from 'vuex'

import rootState from '../index'

Vue.use(Vuex)

export default {
  namespaced: true,
  rootState,

  state: {
    fileExtIcons: {
      doc: 'mdi-file-word-outline',
      docx: 'mdi-file-word-outline',
      eml: 'mdi-email',
      gif: 'mdi-file-image-outline',
      htm: 'mdi-language-html5',
      html: 'mdi-language-html5',
      jpeg: 'mdi-file-image-outline',
      jpg: 'mdi-file-image-outline',
      js: 'mdi-nodejs',
      json: 'mdi-code-json',
      msg: 'mdi-email-outline',
      odt: '',
      pdf: 'mdi-file-pdf-box',
      png: 'mdi-file-image-outline',
      ppt: 'mdi-file-powerpoint-outline',
      pptx: 'mdi-file-powerpoint-outline',
      prm: 'mdi-file-document-outline',
      rtf: 'mdi-file-word-outline',
      thmx: '',
      tiff: 'mdi-file-image-outline',
      tif: 'mdi-file-image-outline',
      txt: 'mdi-file-document-outline',
      vsd: '',
      xls: 'mdi-file-excel-outline',
      xlsx: 'mdi-file-excel-outline',
      xml: '',
      zip: '',
      xxx: 'mdi-file-question-outline',
    },
    menu: {
      x: 0,
      y: 0,
      items: [
        {
          name: 'Neue Datei',
          icon: 'mdi-file-document-plus-outline',
          color: 'green',
          event: 'addFile',
          active: false,
          right: 0,
        },
        {
          name: 'Datei bearbeiten',
          icon: 'mdi-file-document-edit-outline',
          color: 'green',
          event: 'editFile',
          active: false,
          right: 0,
        },
        {
          name: 'Neue Version',
          icon: 'mdi-file-plus-outline',
          color: 'primary',
          event: 'addVersion',
          active: false,
          right: 0,
        },
        {
          name: 'Neuer Ordner',
          icon: 'mdi-folder-plus-outline',
          color: 'orange',
          event: 'addFolder',
          active: false,
          right: 0,
          line: true,
        },
        {
          name: 'Ordner umbenennen',
          icon: 'mdi-folder-edit-outline',
          color: 'info',
          event: 'editFolder',
          active: false,
          right: 0,
        },
        {
          name: 'Element verschieben',
          icon: 'mdi-swap-vertical',
          color: 'brown',
          event: 'selectMoveItem',
          active: false,
          right: 0,
          line: true,
        },
        {
          name: 'Element herunterladen',
          icon: 'mdi-download',
          color: 'orange',
          event: 'downloadItem',
          active: false,
          right: 0,
        },
        {
          name: 'Dateilink kopieren',
          icon: 'mdi-content-copy',
          color: 'info',
          event: 'copyItemLink',
          active: false,
          right: 0,
        },
        {
          name: 'Gelöschte Elemente anzeigen',
          icon: 'mdi-file-eye-outline',
          color: 'success',
          event: 'showHide',
          active: true,
          right: 0,
          line: true,
        },
        {
          name: 'Element löschen',
          icon: 'mdi-delete-outline',
          color: 'red',
          event: 'finalHideItems',
          active: false,
          right: 2,
          admin: true,
        },
        {
          name: 'Element wiederhergestellt ',
          icon: 'mdi-delete-restore',
          color: 'green',
          event: 'restoreHideItem',
          active: false,
          right: 2,
          admin: true,
        },
        {
          name: 'Element entgültig löschen',
          icon: 'mdi-delete-alert-outline',
          color: 'red',
          event: 'finalDeleteItems',
          active: false,
          line: true,
          admin: true,
        },
      ],
    },
    showHideItems: false,

    // tree
    treeItems: [],
    treeActive: [],
    treeOpen: [],
    treeSelected: {},
    selectItem: {},

    // move per drag and drop
    canUpload: true,

    // plugins
    pluginBtn: [
      {
        title: 'Lieferscheine',
        icon: 'mdi-file-table-outline',
        name: 'Lieferscheine',
        color: '',
        right: 32,
        window: { height: 300, width: 450, link: 'import/delivery' },
      },
      {
        title: 'Vertrieb',
        icon: 'mdi-file-document-outline',
        name: 'Vertrieb',
        color: '',
        right: 4096,
        window: { height: 300, width: 450, link: 'import/distribution' },
      },
      {
        title: 'Rechnungen',
        icon: 'mdi-file-document-outline',
        name: 'Buchhaltung',
        color: '',
        right: 16,
        window: { height: 300, width: 450, link: 'import/invoice' },
      },
      {
        title: 'DHR',
        icon: 'mdi-file-chart-outline',
        name: 'QM',
        color: '',
        right: 2048,
        window: { height: 300, width: 450, link: 'import/quality' },
      },
      {
        title: 'Zeichnungen',
        icon: 'mdi-file-image-outline',
        name: 'F&E',
        color: '',
        right: 64,
        window: { height: 300, width: 450, link: 'import/research' },
      },
      {
        title: 'Einkauf',
        icon: 'mdi-file-percent-outline',
        name: 'Einkauf',
        color: '',
        right: 32,
        window: { height: 300, width: 450, link: 'import/sales' },
      },
      {
        title: 'Versand',
        icon: 'mdi-factory',
        name: 'Produktion',
        color: '',
        right: 1024,
        window: { height: 300, width: 450, link: 'import/shipping' },
      },
      {
        title: 'Portegra',
        icon: 'mdi-file-image-outline',
        name: 'PORTEGRA',
        color: '',
        right: 512,
        window: { height: 300, width: 450, link: 'import/portegra' },
      },
    ],

    showDialog: false,
  },
  getters: {
    menu: (state) => state.menu,
    showHideItems: (state) => state.showHideItems,
    // tree
    treeItems: (state) => state.treeItems,
    treeActive: (state) => state.treeActive,
    treeOpen: (state) => state.treeOpen,
    treeSelected: (state) => state.treeSelected,
    // context
    selectItem: (state) => state.selectItem,
    // move per drag and drop
    canUpload: (state) => state.canUpload,
    // plugin
    pluginBtn: (state) => state.pluginBtn,
    // helper
    fileExtIcons: (state, getters, rootState, rootGetters) => (value) =>
      state.fileExtIcons[rootGetters.EXTENTION(value)] ||
      state.fileExtIcons['xxx'],
    showDialog: (state) => state.showDialog,
  },
  mutations: {
    setMenu: (state, items) => (state.menu = items),
    setShowHideItems: (state) => (state.showHideItems = !state.showHideItems),
    // tree
    setTreeItems: (state, items) => (state.treeItems = items),
    setTreeActive: (state, item) => (state.treeActive = item),
    setTreeOpen: (state, item) => (state.treeOpen = item),
    setTreeSelected: (state, item) => (state.treeSelected = item),
    // selection
    setSelectItem: (state, item) => (state.selectItem = item),
    // move per drag and drop
    setCanUpload: (state, value) => (state.canUpload = value),
    // pluginBtn
    setPluginBtn: (state) =>
      state.pluginBtn.forEach((btn) => {
        if (btn.name == 'Lieferscheine') {
          btn.color = 'grey darken-2'
        } else {
          btn.color = state.treeItems.find((f) => f.name == btn.name)?.desc
        }
      }),
    // helper
    scrollToSelected(state, event) {
      // scroll to selected position
      setTimeout(() => {
        console.log('scrolled: ', event)
        let treeBox = document.getElementById('leftSide').firstChild

        let activeElement = document.getElementsByClassName(
          'v-treeview-node--active'
        )

        if (activeElement[0] !== undefined) {
          let offsetTop = activeElement[0].offsetTop - treeBox.scrollTop - 130

          if (offsetTop < 0) {
            treeBox.scrollTop += offsetTop
          } else if (offsetTop > treeBox.offsetHeight - 100) {
            treeBox.scrollTop += offsetTop - treeBox.offsetHeight + 150
          }
        }
      }, 300)
    },
    setShowDialog: (state, value) => (state.showDialog = value),
  },
  actions: {
    // menu set items active
    initMenu: ({ state, rootState }) => {
      let item = state.selectItem

      state.menu.items.forEach((el) => {
        if (el.type != 'line') {
          if (
            (JSON.stringify(item) == '{}' || item === undefined) &&
            el.event != 'showHide'
          ) {
            el.active = false
          } else {
            if (el.event == 'addFile')
              el.active = item.doctype == 0 ? true : false

            if (el.event == 'editFile')
              el.active = item.doctype != 0 ? true : false
            if (el.event == 'addVersion')
              el.active =
                item.doctype != 0 && item.versioned == 1 ? true : false
            if (el.event == 'addFolder')
              el.active = item.doctype == 0 ? true : false
            if (el.event == 'editFolder')
              el.active =
                item.pid != item.id && item.doctype == 0 ? true : false
            if (el.event == 'selectMoveItem')
              el.active = item.pid != item.id || rootState.admin ? true : false
            if (el.event == 'downloadItem')
              el.active = item.doctype != 0 ? true : false
            if (el.event == 'copyItemLink')
              el.active = item.doctype != 0 ? true : false
            if (el.event == 'showHide') {
              el.color = state.showHideItems ? 'error' : 'success'
              el.name = state.showHideItems
                ? 'Gelöschte Elemente ausblenden'
                : 'Gelöschte Elemente anzeigen'
            }
            if (el.event == 'finalHideItems')
              el.active =
                (item.pid != item.id &&
                  rootState.user.app.right & 2 &&
                  item.hide == 0) ||
                (item.pid != item.id &&
                  item.doctype == 0 &&
                  item.count == 0 &&
                  item.hide == 0)
                  ? true
                  : false
            if (el.event == 'restoreHideItem')
              el.active =
                rootState.user.app.right & 2 && item.hide == 1 ? true : false
            if (el.event == 'finalDeleteItems')
              el.active =
                item.pid != item.id &&
                (rootState.admin || (item.doctype == 0 && item.count == 0))
                  ? true
                  : false
          }
        }
      })
    },
    // helper
    async findItem({ dispatch, state }, data) {
      if (!data.items) {
        data.items = state.treeItems
      }

      for (let item of data.items) {
        if (item.id == data.id) {
          return item
        }

        if (item.children) {
          var found = await dispatch('findItem', {
            id: data.id,
            items: item.children,
          })

          if (found) return found
        }
      }
    },
  },
  modules: {},
}
